
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Favorites.WebApi
//----------------------------------------------------------


/**
* Constants for known favorite scopes in legacy storage model.
*/
export module FavoriteScopes {
    export var WORK_PLANS = "Work.Plans";
    export var WIT_QUERYITEMS = "WorkItemTracking.Queries";
    export var VC_PATHS = "VersionControl.Paths";
    export var BUILD_DEFINITIONS = "Build.Definitions";
    export var PROJECTS = "Classification.TeamProjects";
    export var TEAMS = "Team.Teams";
    export var REPOSITORIES = "VersionControl.Repositories";
    export var TEST_PLANS = "TestManagement.Plans";
}

/**
* Constants for known favorite types.
*/
export module FavoriteTypes {
    export var WORK_PLAN = "Microsoft.TeamFoundation.Work.Plans";
    export var WORK_ITERATION = "Microsoft.TeamFoundation.Work.TeamIterations";
    export var WORK_TEAMBACKLOG = "Microsoft.TeamFoundation.Work.TeamBacklogs";
    export var WORK_TEAMBOARD = "Microsoft.TeamFoundation.Work.TeamBoardSets";
    export var WIT_QUERYITEM = "Microsoft.TeamFoundation.WorkItemTracking.QueryItem";
    export var VC_PATH = "Microsoft.TeamFoundation.VersionControl.Path";
    export var BUILD_DEFINITION = "Microsoft.TeamFoundation.Build.Definition";
    export var BUILD_DEFINITION_INITIALIZED = "Microsoft.TeamFoundation.Build.BuildDefinitionInitialized";
    export var PROJECT = "Microsoft.TeamFoundation.Classification.TeamProject";
    export var TEAM = "Microsoft.TeamFoundation.Teams.Team";
    export var TFVC_REPOSITORY = "Microsoft.TeamFoundation.Tfvc.Repository";
    export var GIT_REPOSITORY = "Microsoft.TeamFoundation.Git.Repository";
    export var TEST_PLAN = "Microsoft.TeamFoundation.TestManagement.Plan";
    export var DASHBOARD = "Microsoft.TeamFoundation.Dashboards.Dashboard";
}

